export default __webpack_public_path__ + "static/media/user.89b7b4c7.png";